import PropTypes from 'prop-types';

import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import Button from '@zenbusiness/zui/Button';
import CardHeader from '@zenbusiness/zui/CardHeader';
import ZuiLink from '@zenbusiness/zui/Link';
import Text from '@zenbusiness/zui/Text';
import useMediaQuery from '@zenbusiness/zui/useMediaQuery';

import * as Styled from './RegistrationCard.styles';

function RegistrationCard({ actionLabel, description, externalUrl, imagePath, mobileImagePath = null, title }) {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const imageUrl = isMobile && mobileImagePath ? mobileImagePath : imagePath || mobileImagePath;

  return (
    <Styled.CardWrapper>
      <Styled.Image src={imageUrl} alt={title} />
      <Styled.ContentWrapper>
        <CardHeader subtitle={description} title={<Text size="lg">{title}</Text>} />
        <Button
          clickstreamProps={{
            elementName: 'opening_registration',
            elementValue: title,
          }}
          color="primary"
          component={ZuiLink}
          variant="contained"
          size={isMobile ? 'sm' : 'md'}
          icon={<OpenInNewIcon />}
          iconPosition="end"
          href={externalUrl}
          target="_blank"
          sx={{
            gap: 0.5,
            width: isMobile ? 'auto' : 'fit-content',
          }}
        >
          {actionLabel}
        </Button>
      </Styled.ContentWrapper>
    </Styled.CardWrapper>
  );
}

RegistrationCard.propTypes = {
  actionLabel: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  externalUrl: PropTypes.string.isRequired,
  imagePath: PropTypes.string.isRequired,
  mobileImagePath: PropTypes.string,
  title: PropTypes.string.isRequired,
};

export default RegistrationCard;
